import { render, staticRenderFns } from "./GenericSuccessDialog.vue?vue&type=template&id=0c127340&scoped=true"
import script from "./GenericSuccessDialog.vue?vue&type=script&lang=js"
export * from "./GenericSuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./GenericSuccessDialog.vue?vue&type=style&index=0&id=0c127340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c127340",
  null
  
)

export default component.exports